import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { fragmentMap } from '../../utils/ReactUtils.js';
import { TabBarWrapper } from '../TabBar/TabBarWrapper.js';
import { hostClass } from './Tabs.styles.js';

var defaultProps = {
  openIndex: 0,
  centeredLayout: false
};
var TabsPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    children = props.children,
    className = props.className,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    openIndex = props.openIndex,
    _onChange = props.onChange,
    centeredLayout = props.centeredLayout,
    horizontalAlignment = props.horizontalAlignment,
    navigationActionAs = props.navigationActionAs;
  var navigationTree = fragmentMap(children, function (child, i) {
    return Object.assign(Object.assign({}, child.props), {
      name: i.toString()
    });
  });
  var isCentered = horizontalAlignment === "center" ? true : centeredLayout;
  var inheritedAlignment = centeredLayout === true ? "center" : horizontalAlignment;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement(TabBarWrapper, {
    navigationTree: navigationTree,
    navigationActionAs: navigationActionAs,
    value: openIndex.toString(),
    onChange: function onChange(value, e) {
      return _onChange(parseInt(value, 10), e);
    },
    noMargin: true,
    centeredLayout: isCentered
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-panel")
  }, fragmentMap(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      horizontalAlignment: inheritedAlignment
    });
  })[openIndex]));
}, defaultProps);
TabsPresentation.displayName = "TabsPresentation";

export { TabsPresentation, defaultProps };
